export const GET_SUBSCRIBER_QUERY_KEY = ['subscriber'] as const;
export const UPDATE_SUBSCRIBER_QUERY_KEY = ['update', 'subscriber'] as const;
